module.exports = __webpack_public_path__ + "static/media/medium1.d07af24b.svg";